import { useDialog } from '@dni-hooks/useDialog'
import { Button, type ButtonProps } from '@pets-ui/Button/Button'
import { DIALOG_KEY, DialogConfirmDiscardAll, type DialogConfirmDiscardAllProps } from './DialogConfirmDiscardAll'

export interface ButtonFooterDiscardAllProps extends ButtonProps {
  onDialogConfirm?: DialogConfirmDiscardAllProps['onConfirm']
}

export const ButtonFooterDiscardAll = (props: ButtonFooterDiscardAllProps) => {
  const { onDialogConfirm, onClick, ...rest } = props
  const { openDialog } = useDialog(DIALOG_KEY)

  const handleClick: ButtonProps['onClick'] = (event) => {
    openDialog()
    onClick?.(event)
  }

  return (
    <>
      <DialogConfirmDiscardAll onConfirm={onDialogConfirm} />
      <Button variant="text" color="grey" onClick={handleClick} {...rest}>
        清空購物車
      </Button>
    </>
  )
}
